import { translate, utils } from '@pay24/common'
import { Layout, Modal } from '@ui-kitten/components'
import React, { ReactNode } from 'react'
import {
  Dimensions,
  ScrollView,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
} from 'react-native'
import Icon from './Icon'
import { Text } from './Text'

const { useTranslation } = translate
const { safeAreaUtils } = utils

interface ModalNativeProps {
  visible: boolean
  closeModal: () => void
  children: ReactNode
  title?: string
  backdropColor?: string
  layoutLevel?: string
}

export function ModalNative(props: ModalNativeProps) {
  const {
    visible,
    closeModal,
    children,
    title,
    backdropColor,
    layoutLevel = '3',
  } = props

  const { t } = useTranslation()
  const screenHeight = Dimensions.get('window').height

  const titleComponent = title ? (
    <View style={styles.header}>
      <Text style={styles.title} size={16}>
        {t(title)}
      </Text>
      <Icon name="close" onPress={closeModal} />
    </View>
  ) : null

  return (
    <Modal
      visible={visible}
      backdropStyle={{
        backgroundColor: backdropColor ?? 'rgba(0,0,0,0.5)',
      }}
      style={styles.modal}
    >
      <TouchableWithoutFeedback onPress={closeModal}>
        <View style={StyleSheet.absoluteFill} />
      </TouchableWithoutFeedback>
      <Layout
        level={layoutLevel}
        style={[
          styles.layout,
          {
            paddingBottom: safeAreaUtils.getStatusBarHeight() + 8,
            maxHeight: screenHeight * 0.55,
          },
        ]}
      >
        {titleComponent}
        <ScrollView
          contentContainerStyle={styles.scrollContent}
          showsVerticalScrollIndicator={false}
        >
          {children}
        </ScrollView>
      </Layout>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modal: {
    margin: 0,
    justifyContent: 'flex-end',
    width: '100%',
    bottom: 0,
  },
  layout: {
    width: '100%',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingHorizontal: 12,
    paddingTop: 12,
    paddingBottom: 16,
    overflow: 'hidden',
  },
  scrollContent: {
    flexGrow: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
  },
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    flex: 1,
  },
})
